import React from 'react';
import { FaInstagram, FaTwitter, FaLinkedin, FaGithub } from 'react-icons/fa';

const SocialIcon = ({ Icon, url, colorClass }) => (
  <a
    href={url}
    target="_blank"
    rel="noopener noreferrer"
    className={`
      flex items-center justify-center w-12 h-12 rounded-full 
      bg-white/10 hover:bg-white/20 backdrop-blur-md border border-white/10
      transition-all duration-300 transform hover:scale-110 hover:-translate-y-1
      ${colorClass} group
    `}
  >
    <Icon className="w-6 h-6 text-white group-hover:text-white transition-colors" />
  </a>
);

const Connectionstab = () => {
  return (
    <div className='flex gap-4'>
      <SocialIcon
        Icon={FaInstagram}
        url="https://www.instagram.com/sierra_alpha_43/"
        colorClass="hover:bg-gradient-to-tr hover:from-yellow-400 hover:via-red-500 hover:to-purple-500"
      />
      <SocialIcon
        Icon={FaTwitter}
        url="https://twitter.com/Sierra_alpha_43"
        colorClass="hover:bg-[#1DA1F2]"
      />
      <SocialIcon
        Icon={FaLinkedin}
        url="https://www.linkedin.com/in/sarvadnya-awaghad/"
        colorClass="hover:bg-[#0077B5]"
      />
      <SocialIcon
        Icon={FaGithub}
        url="https://github.com/Sarvadnyaawaghad150503"
        colorClass="hover:bg-[#333]"
      />
    </div>
  );
};

export default Connectionstab;
